import { ITextProps } from './Text.d';
import { Paragraph } from './Text.styles';

export const Text = ({ children }: ITextProps) => {
    return <Paragraph>{children}</Paragraph>;
};
